$(document).ready(function(){
  $(".main_slidedata").slick({
    dots: false,
    appendArrows: '.main_slidedata_btn',
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    asNavFor: '.thumb_slidedata',
    prevArrow: '<button class="slick-prev-main" aria-label="Previous" type="button"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="slick-next-main" aria-label="Next" type="button"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  });

  $('.thumb_slidedata').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    arrows: false,
    infinite: false,
    asNavFor: '.main_slidedata',
    dots: false,
    prevArrow: '<button class="slick-prev-thumb" aria-label="Previous" type="button"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button class="slick-next-thumb" aria-label="Next" type="button"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          vertical: false,
        }
      }
    ]
  });
  
});
